<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="satellites"
    class="m-edition-billing-satellites"
  >
    <!-- Pestañas: mismas clases que el submenu de productos en app-academy -->
    <div class="m-edition-section-content-info m-edition-billing-satellites-submenu">
      <div class="m-edition-section-content-info-submenu m-edition-section-content-info-submenu-products">
        <ul>
          <li
            v-for="tab in tabs"
            :key="tab.key"
          >
            <a
              href="#"
              :class="[currentTab === tab.key
                ? 'submenu-item-active submenu-item-active-products'
                : '']"
              @click.prevent="changeTab(tab.key)"
            >
              {{ tab.text }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <blockquote class="quote quote-products-primary quote-first">
      <p>
        <span>{{ $t(`mEditionBillingSatellites.quote.${currentTab}.firstText`) }}</span>
        <span>{{ $t('mEditionBillingSatellites.quote.secondText') }}</span>
      </p>
    </blockquote>

    <div class="display-flex-row-center space-between margin-top-large margin-bottom-large">
      <AtomButtonSecondary
        :button-secondary="buttonCreate"
        element="create"
        @executeMethod="openCreateModal"
      />
      <AtomInputPrimary
        v-model="search"
        placeholder="Buscar"
        name="search"
        type="text"
      />
    </div>

    <div
      v-if="showListLoadingState"
      key="listLoadingState"
    >
      <AtomLoadingSecondary/>
    </div>

    <div
      v-else-if="!searchedSatelites.length"
      key="empty"
      class="m-edition-billing-satellites-empty"
    >
      <p>{{ $t(`mEditionBillingSatellites.empty.${currentTab}`) }}</p>
      <small>{{ $t('mEditionBillingSatellites.empty.action') }}</small>
    </div>

    <div
      v-else
      key="list"
      class="m-edition-billing-satellites-list"
    >
      <a
        v-for="satelite in searchedSatelites"
        :key="satelite.id"
        class="m-edition-billing-satellites-item"
        href="#"
        @click.prevent="openDetailModal(satelite)"
      >
        <MoleculeEditionBillingSatellitesCard :satelite="satelite"/>
      </a>
    </div>

  </div>
</template>

<script>
import { droopsHabilitados, sufijoDe } from '@/plugins/satelites/droops'

export default {
  name: 'MoleculeEditionBillingSatellites',

  components: {
    MoleculeEditionBillingSatellitesCard: () =>
      import('@/components/molecules/MoleculeEditionBillingSatellitesCard')
  },

  data () {
    return {
      currentTab: 'juedroop',
      planes: {},
      satelites: droopsHabilitados().reduce((lista, clave) => ({ ...lista, [clave]: [] }), {}),
      search: '',
      showListLoadingState: false,
      showLoadingState: true,

      // Los Droops que todavia no estan terminados se ocultan con su flag de config (ver droops.js)
      tabs: droopsHabilitados().map(clave => ({
        key: clave,
        text: this.$t(`mEditionBillingSatellites.tabs.${clave}`)
      }))
    }
  },

  computed: {
    buttonCreate () {
      return {
        class: 'a-button-billing-secondary',
        component: '',
        icon: 'fas fa-plus',
        method: 'executeMethod',
        text: this.$t(`mEditionBillingSatellites.buttonPrimary.create${sufijoDe(this.currentTab)}`),
        type: 'button'
      }
    },

    searchedSatelites () {
      const lista = this.satelites[this.currentTab] || []

      if (!this.search) {
        return lista
      }

      const termino = this.search.toLowerCase()

      return lista.filter(satelite =>
        `${satelite.titulo} ${satelite.descripcion || ''}`.toLowerCase().includes(termino)
      )
    },

    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    // El modal avisa cuando termino: se refresca solo la pestaña que cambio
    updatedData () {
      if (this.$modal.methodToRun === 'readSatelites') {
        this.readSatelites(this.currentTab)
      }

      if (this.$modal.methodToRun === 'toggleEstadoSatelite') {
        this.toggleEstado(this.$modal.element.satelite, this.$modal.element.nuevoEstado)
      }
    }
  },

  created () {
    this.readPlanes()
    this.readSatelites(this.currentTab, true)
  },

  methods: {
    changeTab (tab) {
      if (this.currentTab === tab) {
        return
      }

      this.currentTab = tab
      this.search = ''

      // Solo se pide la primera vez que se entra a la pestaña
      if (!this.satelites[tab].length) {
        this.readSatelites(tab)
      }
    },

    endpointDe (tab, accion) {
      const sufijo = sufijoDe(tab)

      return accion === 'read'
        ? `readSatelites${sufijo}`
        : `${accion}Satelite${sufijo}`
    },

    openCreateModal () {
      this.$modal.showModal('MoleculeEditionBillingSatellitesModal', {
        planes: this.planes[this.currentTab] || [],
        tab: this.currentTab
      })
    },

    openDetailModal (satelite) {
      this.$modal.showModal('MoleculeEditionBillingSatellitesModalDetail', {
        satelite: satelite,
        tab: this.currentTab
      })
    },

    openDeleteModal (satelite) {
      this.$modal.showModal('MoleculeEditionBillingSatellitesModalDelete', {
        satelite: satelite,
        tab: this.currentTab
      })
    },

    readPlanes () {
      this.$services.read('satelite', 'readPlanes')
        .then(response => {
          this.planes = response.data
        })
        .catch(() => {
          this.$alerts.pushAlert('mEditionBillingSatellites', 'readPlanes', 'error', 'a-alert-danger')
        })
    },

    readSatelites (tab, esPrimeraCarga = false) {
      this.showListLoadingState = !esPrimeraCarga

      this.$services.read('satelite', this.endpointDe(tab, 'read'))
        .then(response => {
          this.satelites = Object.assign({}, this.satelites, { [tab]: response.data })
        })
        .catch(() => {
          this.$alerts.pushAlert('mEditionBillingSatellites', 'readSatelites', 'error', 'a-alert-danger')
        })
        .finally(() => {
          this.showListLoadingState = false
          this.showLoadingState = false
        })
    },

    toggleEstado (satelite, nuevoEstado) {
      const data = { satelite: { activo: nuevoEstado } }

      this.$services.update('satelite', this.endpointDe(this.currentTab, 'update'), data, [satelite.id])
        .then(() => {
          this.$modal.closeModal()
          this.$alerts.pushAlert('mEditionBillingSatellites', 'updateSatelite', 'success', 'a-alert-success')
          this.readSatelites(this.currentTab)
        })
        .catch(() => {
          this.$alerts.pushAlert('mEditionBillingSatellites', 'updateSatelite', 'error', 'a-alert-danger')
        })
    }
  }
}
</script>
